import React from 'react';
import PlaceholderBar from '../PlaceholderBar/PlaceholderBar';
import styles from './AboutRelationship.scss';
import { SkeletonProps } from '../../interfaces/SkeletonProps';
import Refresh from '../Refresh/Refresh';

interface AboutRelationshipSkeleton extends SkeletonProps {
  inline?: boolean;
}

const AboutRelationshipSkeleton: React.FunctionComponent<AboutRelationshipSkeleton> = ({
  animated,
  onRefresh,
  displayRefreshButton,
  refreshButtonLabel,
  inline,
}) => (
  <Refresh
    onRefresh={onRefresh}
    className={inline ? styles.aboutRelationship : ''}
    displayRefreshButton={displayRefreshButton}
    buttonLabel={refreshButtonLabel}
  >
    <PlaceholderBar
      animated={animated}
      height={98}
      width={98}
      marginRight={24}
    />
    <div className="jg-flex-g1">
      <PlaceholderBar
        animated={animated}
        height={24}
        width="90%"
        colour="nobel"
      />
      <PlaceholderBar animated={animated} height={19} width="80%" />
    </div>
  </Refresh>
);

export default AboutRelationshipSkeleton;
